import { ShoppingBag, ShoppingBagOutlined } from '@mui/icons-material'
import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import logo from '../../assets/Images/Logo.png'
import leftimg from '../../assets/Images/Screen.png'

function LeftSide() {
  return (
    <Box className='bg-second-light h-100 overflow-auto p-5'>
      <Box className='d-flex align-items-center'>
        {/* <ShoppingBagOutlined className='text-main' sx={{fontSize:'64px'}} /> */}
        <Box component={'img'} src={logo} height={'100px'}></Box>
        <Box>
        <Typography variant='h4' className='m-0 p-0 fw-bold logo-text text-dark-main' sx={{lineHeight:'normal'}}> <span>Wholesale</span><span className='text-main'> Pro</span></Typography>
        <Typography variant='body2' className='text-grey logo-text'>B2B. BETTER TOGETHER</Typography>
        </Box>
      </Box>
      <Box className='p-5'>
        <Typography variant='h3' className='fw-bold mb-3 text-dark-main'>Welcome Back!</Typography>
        <Typography variant='h6' className='text-grey'>Sign in to access your account</Typography>
        <Box component={'img'} src={leftimg} className='w-100'></Box>
      </Box>
    </Box>
  )
}

export default LeftSide
